/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Pause30 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={30} height={30} viewBox="0 0 30 30" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={15} cy={15} r={15} />
      <path fill="currentColor" d="M11 7h2v16h-2zm6 0h2v16h-2z" />
    </g>
  </svg>
);

export const __descriptor_Pause = {
  name: "Pause",
  instances: [{ size: 30, Component: Pause30 }],
} as const;
